import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { WithdrawMoneySelectorPage } from './withdraw-money-selector';

@NgModule({
  declarations: [
    WithdrawMoneySelectorPage,
  ],
  imports: [
    IonicPageModule.forChild(WithdrawMoneySelectorPage),
  ],
})
export class WithdrawMoneySelectorPageModule {}



// WEBPACK FOOTER //
// ./src/pages/withdraw-money-selector/withdraw-money-selector.module.ts